import styled from "styled-components";
import { DialogScroll } from "@ebscois/react-component-library";

export const DialogContent = styled(DialogScroll)`
  margin: ${({ theme }) => theme.space.md};
  margin-top: 0;
`;
